import React from "react";
import { Formik, ErrorMessage } from "formik";
import { Form, FormCheck } from "react-bootstrap";
import { EN, fontStyle } from "../../ui/constants";
import { Box, Button, Card, Grid } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";

const findById = (id, teams) => {
  if (id) {
    if (teams?.find(({ team_id }) => team_id === id)) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

class JoinTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCopyMember: false,
      teamId:''
    };
  }
  validateEmpty = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    }
    return error;
  };

  render() {
    const { teams, allTeams, onJoinToEvent, event } = this.props;
    return (
      <Formik
        initialValues={{
          team: null,
          role: "",
          isCopy: false,
        }}
        validate={(values) => {
          let errors = {
            team: this.validateEmpty(values.team),
          };
          Object.keys(errors).forEach((key) => {
            if (errors[key] === undefined) {
              delete errors[key];
            }
          });
          return errors;
        }}
        onSubmit={(values) => {
          onJoinToEvent(values.team, values.role, values.isCopy);
        }}
      >
        {({ values, handleChange, handleSubmit, handleBlur }) => (
          <Form
            onSubmit={(...args) => {
              return handleSubmit(...args);
            }}
          >
            <Box p={2} className="event-detail-screen">
              <Card elevation={0}>
                {event.isPast ? (
                  <Box bgcolor="#F7F7F7" p={1} border="1px solid #DCDCDC">
                    <Box style={fontStyle} mt={1}>
                      <span style={{ marginRight: 4 }}>
                        <BlockIcon />
                      </span>
                      This event has passed
                    </Box>
                  </Box>
                ) : (
                  <Box
                    bgcolor="#F7F7F7"
                    p={2}
                    border="1px solid #DCDCDC"
                    width="100%"
                    display="flex"
                    justifyContent="space-evenly"
                  >
                    <Grid container spacing={2} justifyContent="space-between">
                        <Grid item lg={5} xs={12} xl={5} md={5}>
                        <Form.Control
                          as="select"
                          name="team"
                          value={values.team}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option defaultValue>Select team of event</option>
                          <optgroup label="Re-register my previous team for this event">
                            {teams.map((val, k) => {
                              return (
                                <option
                                  key={k}
                                  id={val.team_id}
                                  value={val.team_id}
                                >
                                  {val.team_name}
                                </option>
                              );
                            })}
                          </optgroup>
                          <optgroup label="All Teams">
                            {allTeams.map((val, k) => {
                              return (
                                <option key={k} id={val.id} value={val.id}>
                                  {val.name}
                                </option>
                              );
                            })}
                          </optgroup>
                        </Form.Control>
                        <ErrorMessage
                          name="team"
                          className="submit"
                          component="Box"
                        />
                        <Box className="check-box-event-detail">
                          <FormCheck
                            checked={values.isCopy}
                            type="checkbox"
                            name="isCopy"
                            value={!!values.isCopy}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label="Copy past team members"
                          />
                        </Box>
                      </Grid>

                      <Grid item lg={5} xs={12} xl={5} md={5}>
                        {findById(parseInt(values.team), teams) ||
                        values.team === "" ? (
                          <Form.Control
                            as="select"
                            name="role"
                            value={values.role}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option defaultValue>Choose your role</option>
                            {EN.role.map((val, k) => {
                              return (
                                <option key={k} value={val}>
                                  {val}
                                </option>
                              );
                            })}
                          </Form.Control>
                        ) : null}
                      </Grid>

                      <Grid item lg={2} xs={12} xl={2} md={2}>
                        <Button
                          variant="contained"
                          disableElevation
                          type="submit"
                          style={{
                            backgroundColor: "#E00000",
                            color: "white",
                            textTransform: "capitalize",
                          }}
                        >
                          Join
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Card>
            </Box>
          </Form>
        )}
      </Formik>
    );
  }
}

export default JoinTeam;
